import { ThemeUICSSObject } from '@apia/theme';

const buttons: Record<string, ThemeUICSSObject> = {
  calendarDay: {
    variant: 'buttons.paper-sm',
    px: 0,
    textAlign: 'center',

    '&.react-calendar__tile--active': (theme) =>
      theme.palette.getOneState(
        {
          backgroundColor: 'palette.background.paper',
          color: 'palette.text.primary',
        },
        'selected',
      ),
  },
};

export default buttons;
